module.exports = __webpack_public_path__ + "static/liars-poker-4ec5224a5bde7f92ec3bcfc08df15e77.jpg";